var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHolidayHouse = function SvgHolidayHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.34,
    height: 28.787
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Holiday house",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3589",
    d: "m23.425 18.737-8.652-5.7-4.521 2.808",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3590",
    d: "M28.326 27.46s-8.507-2.295-15.257-2.295A30.849 30.849 0 0 0 1.326 27.46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 483",
    transform: "translate(18.097)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.99,
    cy: 3.99,
    r: 3.99,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.99,
    cy: 3.99,
    r: 2.99
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3593",
    d: "M21.185 20.313v4.627"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 380",
    d: "M8.185 20.313v4.627"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3592",
    d: "m1.288 11.005 11.267-3.048 6.742 4.235 5.309-1.187 4.405 2.05",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 388",
    d: "M5.738 25.165V20.94"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 484",
    transform: "translate(.238 10.813)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8922",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M17.487 21.71v-1.897"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M16.414 19.813h1.073"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8923",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M12.541 21.71v-1.897"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M11.468 19.813h1.073"
  })))));
};
export default SvgHolidayHouse;